import download from 'downloadjs';
import { Buffer } from 'buffer/';

export const downloadExcelData = (data: string, filename: string) => {
    const buffer = new Buffer(data, 'base64');
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    download(blob, `${filename}.xlsx`);
};
